var _defs, _text, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _text2, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteHitseriescloudIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236.85 73.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;stroke:#231f20;stroke-miterlimit:10;}.cls-1{stroke-width:0.2px;}.cls-2{font-size:9.06px;stroke-width:0.2px;font-family:Helvetica-Bold, Helvetica;font-weight:700;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: -5.29,
    y: 30.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.39,37.84V6.17H12V18.24H24.27V6.17h6.58V37.84H24.27V23.7H12V37.84Z",
    transform: "translate(-5.29 30.81)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.35,37.81l-6.57,0L32.56,6.19l6.57,0Z",
    transform: "translate(-5.29 30.81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.44,6.17v5.61H57V37.84H50.31V11.78H40.79V6.17Z",
    transform: "translate(-5.29 30.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.63,28.06a6.6,6.6,0,0,0,1.17,3.25q1.61,1.95,5.49,1.95a11.65,11.65,0,0,0,3.78-.51,3.68,3.68,0,0,0,2.75-3.68,2.74,2.74,0,0,0-1.35-2.43,14.69,14.69,0,0,0-4.28-1.48l-3.33-.75c-3.28-.75-5.54-1.55-6.76-2.43Q66,19.79,66,15.13a9.23,9.23,0,0,1,3-7.07c2-1.88,5-2.81,9-2.81A13.48,13.48,0,0,1,86.4,7.9a9.53,9.53,0,0,1,3.65,7.7H83.86a4.55,4.55,0,0,0-2.49-4.06,8.34,8.34,0,0,0-3.84-.79,7.14,7.14,0,0,0-4.07,1,3.28,3.28,0,0,0-1.52,2.88,2.72,2.72,0,0,0,1.5,2.53,18.37,18.37,0,0,0,4.09,1.31l5.41,1.31a13.77,13.77,0,0,1,5.34,2.3A7.87,7.87,0,0,1,91,28.58a9.23,9.23,0,0,1-3.26,7.21q-3.27,2.87-9.23,2.86T69,35.83a9.43,9.43,0,0,1-3.49-7.77Z",
    transform: "translate(-5.29 30.81)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.45,11.78H98.14V18.5h15V24h-15v8.14H115.2v5.7H91.84V6.17h22.61Z",
    transform: "translate(-5.29 30.81)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.05,7a7.64,7.64,0,0,1,2.89,2.21,10,10,0,0,1,1.55,2.66,9.15,9.15,0,0,1,.57,3.33A9.67,9.67,0,0,1,141,19.63a6.25,6.25,0,0,1-3.66,3.08,5.77,5.77,0,0,1,3,2.51,10.68,10.68,0,0,1,.89,5v2.12a16.88,16.88,0,0,0,.17,3,2.65,2.65,0,0,0,1.19,1.8v.8h-7.11c-.19-.7-.33-1.27-.42-1.7a15.41,15.41,0,0,1-.27-2.73l0-2.94c0-2-.37-3.37-1-4s-1.88-1-3.67-1h-6.29V37.84h-6.29V6.17h14.74A12.81,12.81,0,0,1,137.05,7Zm-13.31,4.68v8.51h6.93a7.1,7.1,0,0,0,3.1-.52c1.22-.6,1.83-1.79,1.83-3.56q0-2.88-1.77-3.87a6.28,6.28,0,0,0-3-.56Z",
    transform: "translate(-5.29 30.81)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.21,37.84h-6.4V6.17h6.4Z",
    transform: "translate(-5.29 30.81)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.13,11.78H158.82V18.5h15V24h-15v8.14h17.06v5.7H152.53V6.17h22.6Z",
    transform: "translate(-5.29 30.81)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.65,28.06a6.5,6.5,0,0,0,1.18,3.25q1.59,1.95,5.48,1.95a11.61,11.61,0,0,0,3.78-.51,3.68,3.68,0,0,0,2.76-3.68,2.74,2.74,0,0,0-1.35-2.43,14.69,14.69,0,0,0-4.28-1.48l-3.34-.75c-3.28-.75-5.53-1.55-6.76-2.43C177,20.52,176,18.24,176,15.13a9.22,9.22,0,0,1,3-7.07c2-1.88,5-2.81,9-2.81a13.45,13.45,0,0,1,8.41,2.65,9.53,9.53,0,0,1,3.66,7.7h-6.19a4.57,4.57,0,0,0-2.49-4.06,8.34,8.34,0,0,0-3.84-.79,7.11,7.11,0,0,0-4.07,1A3.26,3.26,0,0,0,182,14.66a2.72,2.72,0,0,0,1.5,2.53,18.18,18.18,0,0,0,4.09,1.31L193,19.81a13.65,13.65,0,0,1,5.33,2.3,7.84,7.84,0,0,1,2.76,6.47,9.2,9.2,0,0,1-3.27,7.21q-3.25,2.87-9.22,2.86T179,35.83a9.46,9.46,0,0,1-3.49-7.77Z",
    transform: "translate(-5.29 30.81)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(203 69)"
  }, "CLOUD")), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.19,15.27a5.92,5.92,0,0,0-5.82-4.84,5.82,5.82,0,0,0-2.59.62,7.11,7.11,0,0,0-14,1.75,7.11,7.11,0,0,0,0,14.22h21.33a5.92,5.92,0,0,0,1.08-11.75Z",
    transform: "translate(-5.29 30.81)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.89,8.06a4.74,4.74,0,0,0-4.74,4.74",
    transform: "translate(-5.29 30.81)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHitseriescloudIcon);
export default __webpack_public_path__ + "static/media/white_hitseriescloud_icon.3e3d22211fd7494ddd3034c2fc7ca167.svg";
export { ForwardRef as ReactComponent };